import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  FormFeedback,
  Input,
} from 'reactstrap';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import cn from 'classnames';

class ConfirmSMSModal extends Component {
  state = {
    data: {
      code: '',
    },
    error: '',
  };

  onChange = e => {
    const target = e.target;

    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.sendSms(this.state.data);
  };

  render() {
    const { isOpen, toggleModal, isPhoneCall, error } = this.props;
    const { code } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={toggleModal} centered autoFocus>
        <ModalHeader toggle={toggleModal}>
          <FormattedMessage id="confirm_phone.modal.header" defaultMessage="Confirm phone number" />
        </ModalHeader>
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <ModalBody className="py-4">
            <FormGroup className={cn('no-margin', { ['has-error']: error })} row>
              <Label htmlFor="sms_code">
                {isPhoneCall ? (
                  <FormattedHTMLMessage tagName="span" id="profile.modal.phone-code" />
                ) : (
                  <FormattedMessage id="profile.modal.code" defaultMessage="Code" />
                )}
              </Label>

              <Input
                name="code"
                id="sms_code"
                onChange={this.onChange}
                value={code}
                maxLength={10}
                autoFocus
                required
              />
              {error && <small className="form-text">{error}</small>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="button" className="btn-sm" color="light" onClick={toggleModal}>
              <FormattedMessage id="main.cancel" defaultMessage="Cancel" />
            </Button>
            <Button className="btn-sm" type="submit" color="primary">
              <FormattedMessage id="main.save" defaultMessage="Save" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default ConfirmSMSModal;
